import { datadogRum } from "@datadog/browser-rum";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";
import { createRoot } from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import { AppProvider } from "./Context/Context";
import { store } from "./store";
import App from "./App";
import "./index.css";
import { getSocketEndPoint, getDynamicApiLink } from "./util/network/apiUrl";

if (process.env.REACT_APP_DD_APPLICATION_ID && process.env.REACT_APP_DD_CLIENT_TOKEN) {
  datadogRum.init({
    applicationId: process.env.REACT_APP_DD_APPLICATION_ID,
    clientToken: process.env.REACT_APP_DD_CLIENT_TOKEN,
    site: process.env.REACT_APP_DD_SITE || "us3.datadoghq.com",
    service: process.env.REACT_APP_DD_SERVICE || "lgvone-frontend",
    env: process.env.REACT_APP_DD_ENV || "dev",
    version: process.env.REACT_APP_VERSION || "1.0.0",
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
    allowedTracingUrls: [getSocketEndPoint(), getDynamicApiLink()]
      .filter(Boolean)
      .map((url) => ({ match: url, propagatorTypes: ["tracecontext"] }))
  });
}

export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.handleRedirectPromise().then((response) => {
  if (response !== null && response.account) {
    msalInstance.setActiveAccount(response.account);
  } else {
    const allAccounts = msalInstance.getAllAccounts();
    if (allAccounts.length > 0) {
      msalInstance.setActiveAccount(allAccounts[0]);
    }
  }

  const activeAccount = msalInstance.getActiveAccount();
  if (activeAccount && datadogRum.getInternalContext()) {
    datadogRum.setUser({
      id: activeAccount.localAccountId,
      name: activeAccount.name,
      email: activeAccount.username
    });
  }

  const root = createRoot(document.getElementById("root"));

  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <MsalProvider instance={msalInstance}>
          <ReduxProvider store={store}>
            <AppProvider>
              <App />
            </AppProvider>
          </ReduxProvider>
        </MsalProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
});
